import { render, staticRenderFns } from "./replaceClass.vue?vue&type=template&id=59de7a12&scoped=true&"
import script from "./replaceClass.vue?vue&type=script&lang=js&"
export * from "./replaceClass.vue?vue&type=script&lang=js&"
import style0 from "./replaceClass.vue?vue&type=style&index=0&id=59de7a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de7a12",
  null
  
)

export default component.exports